export default "__VITE_ASSET__T49qskI8__"